
// MATTER FLOW OF INSTITUTE SAINT PAUL THEOLOGICAL SEMINARY
import { Position } from "react-flow-renderer"

export const nodes = [
    //PROPEDEUTICO ------------------------------------------
    {
        id: 'P_0',
        type: 'input',
        data: { label: 'PROPEDEUTICO' },
        position: { x: 20, y: 70 },
        className: 'light',
        style: { backgroundColor: 'rgba(239, 255, 253, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_0_1',
        data: { label: 'Taller de Lectura' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_0',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_0_2',
        data: { label: 'Taller de Escritura' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_0',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_0_3',
        data: { label: 'Taller de Comunicación verbal' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_0',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_0_4',
        data: { label: 'Estrategias de aprendizaje' },
        position: { x: 150, y: 210 },
        className: 'light',
        parentNode: 'P_0',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_0_5',
        data: { label: 'Definición ministerial' },
        position: { x: 500, y: 218 },
        className: 'light',
        parentNode: 'P_0',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_0_6',
        data: { label: 'Doctrina de catecumenos' },
        position: { x: 800, y: 210 },
        className: 'light',
        parentNode: 'P_0',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
    //PRIMER SEMESTRE ------------------------------------------------------------------
    {
        id: 'P_1',
        data: { label: 'PRIMER SEMESTRE' },
        position: { x: 20, y: 470 },
        className: 'light',
        style: { backgroundColor: 'rgba(184, 255, 249, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_1_1',
        data: { label: 'Principios rectores' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_1',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_1_2',
        data: { label: 'Etica pastoral familiar' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_1',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_1_3',
        data: { label: 'Taller de enseñanza I' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_1',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_1_4',
        data: { label: 'Historia de la iglesia ICIAR' },
        position: { x: 150, y: 210 },
        className: 'light',
        parentNode: 'P_1',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_1_5',
        data: { label: 'Administración eclesiástica' },
        position: { x: 500, y: 210 },
        className: 'light',
        parentNode: 'P_1',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_1_6',
        data: { label: 'Evangelismo' },
        position: { x: 800, y: 218 },
        className: 'light',
        parentNode: 'P_1',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
    //SEGUNDO SEMESTRE ------------------------------------------------------------------
    {
        id: 'P_2',
        data: { label: 'SEGUNDO SEMESTRE' },
        position: { x: 20, y: 870 },
        className: 'light',
        style: { backgroundColor: 'rgba(133, 244, 255, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_2_1',
        data: { label: 'Higiene general' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_2',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_2_2',
        data: { label: 'Teología I' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_2',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_2_3',
        data: { label: 'Taller de enseñanza II' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_2',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_2_4',
        data: { label: 'Antiguo testamento' },
        position: { x: 150, y: 218 },
        className: 'light',
        parentNode: 'P_2',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_2_5',
        data: { label: 'Ética pastoral eclesiástica y social' },
        position: { x: 500, y: 210 },
        className: 'light',
        parentNode: 'P_2',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_2_6',
        data: { label: 'Discipulado' },
        position: { x: 800, y: 218 },
        className: 'light',
        parentNode: 'P_2',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
    //TERCER SEMESTRE ------------------------------------------------------------------
    {
        id: 'P_3',
        data: { label: 'TERCER SEMESTRE' },
        position: { x: 20, y: 1270 },
        className: 'light',
        style: { backgroundColor: 'rgba(66, 194, 255, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_3_1',
        data: { label: 'Doctrina del Espiritu Santo' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_3',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_3_2',
        data: { label: 'Nuevo testamento' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_3',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_3_3',
        data: { label: 'Taller de enseñanza III' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_3',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_3_4',
        data: { label: 'Teología II' },
        position: { x: 150, y: 218 },
        className: 'light',
        parentNode: 'P_3',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_3_5',
        data: { label: 'Hermenéutica I' },
        position: { x: 500, y: 218 },
        className: 'light',
        parentNode: 'P_3',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_3_6',
        data: { label: 'Doctrina de catecúmenos' },
        position: { x: 800, y: 218 },
        className: 'light',
        parentNode: 'P_3',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
    //CUARTO SEMESTRE ------------------------------------------------------------------
    {
        id: 'P_4',
        data: { label: 'CUARTO SEMESTRE' },
        position: { x: 20, y: 1670 },
        className: 'light',
        style: { backgroundColor: 'rgba(114, 255, 255, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_4_1',
        data: { label: 'Sanidad Divina' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_4',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_4_2',
        data: { label: 'Profecía I' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_4',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_4_3',
        data: { label: 'Teología III' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_4',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_4_4',
        data: { label: 'Consejería Pastoral II' },
        position: { x: 150, y: 218 },
        className: 'light',
        parentNode: 'P_4',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_4_5',
        data: { label: 'Hermenéutica II' },
        position: { x: 500, y: 218 },
        className: 'light',
        parentNode: 'P_4',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_4_6',
        data: { label: 'Taller de Homilética I' },
        position: { x: 800, y: 218 },
        className: 'light',
        parentNode: 'P_4',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
    //QUINTO SEMESTRE ------------------------------------------------------------------
    {
        id: 'P_5',
        data: { label: 'QUINTO SEMESTRE' },
        position: { x: 20, y: 2070 },
        className: 'light',
        style: { backgroundColor: 'rgba(0, 215, 255, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_5_1',
        data: { label: 'Profecía II' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_5',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_5_2',
        data: { label: 'Taller de Homilética II' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_5',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_5_3',
        data: { label: 'Apologética I' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_5',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_5_4',
        data: { label: 'Educación Musical' },
        position: { x: 150, y: 218 },
        className: 'light',
        parentNode: 'P_5',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_5_5',
        data: { label: 'Formación Biblica' },
        position: { x: 500, y: 218 },
        className: 'light',
        parentNode: 'P_5',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_5_6',
        data: { label: 'Introducción a los idiomas Biblicos I' },
        position: { x: 800, y: 218 },
        className: 'light',
        parentNode: 'P_5',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
    //SEXTO SEMESTRE ------------------------------------------------------------------
    {
        id: 'P_6',
        type: 'output',
        data: { label: 'SEXTO SEMESTRE' },
        position: { x: 20, y: 2470 },
        className: 'light',
        style: { backgroundColor: 'rgba(0, 155, 255, 0.2)', width: 1120, height: 300 },
    },
    {
        id: 'P_6_1',
        data: { label: 'Taller de Homilética III' },
        position: { x: 150, y: 70 },
        className: 'light',
        parentNode: 'P_6',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Bottom,
    },
    {
        id: 'P_6_2',
        data: { label: 'Apologética II' },
        position: { x: 500, y: 70 },
        className: 'light',
        parentNode: 'P_6',
        extent: 'parent',
        sourcePosition: Position.Right,
        targetPosition: Position.Left,
    },
    {
        id: 'P_6_3',
        data: { label: 'Formación Misionera' },
        position: { x: 800, y: 70 },
        className: 'light',
        parentNode: 'P_6',
        extent: 'parent',
        sourcePosition: Position.Bottom,
        targetPosition: Position.Left,
    },
    {
        id: 'P_6_4',
        data: { label: 'Carácter Ministerial' },
        position: { x: 150, y: 218 },
        className: 'light',
        parentNode: 'P_6',
        extent: 'parent',
        sourcePosition: Position.Top,
        targetPosition: Position.Right,
    },
    {
        id: 'P_6_5',
        data: { label: 'Teología Contemporanea' },
        position: { x: 500, y: 218 },
        className: 'light',
        parentNode: 'P_6',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
    },
    {
        id: 'P_6_6',
        data: { label: 'Introducción a los idiomas Biblicos I' },
        position: { x: 800, y: 218 },
        className: 'light',
        parentNode: 'P_6',
        extent: 'parent',
        sourcePosition: Position.Left,
        targetPosition: Position.Top,
    },
]


export const edges = [
    //PROPEDEUTICO ---------------------------------------------------------
    {
        id: 'e1-2-P_0',
        source: 'P_0_1',
        target: 'P_0_2',
        animated: true,
    },
    {
        id: 'e2-3-P_0',
        source: 'P_0_2',
        target: 'P_0_3',
        animated: true,
    },
    {
        id: 'e3-4-P_0',
        source: 'P_0_3',
        target: 'P_0_6',
        animated: true,
    },
    {
        id: 'e4-5-P_0',
        source: 'P_0_6',
        target: 'P_0_5',
        animated: true,
    },
    {
        id: 'e5-6-P_0',
        source: 'P_0_5',
        target: 'P_0_4',
        animated: true,
    },
    {
        id: 'e6-1-P_0',
        source: 'P_0_4',
        target: 'P_0_1',
        animated: true,
    },
    //PRIMER SEMESTRE ------------------------------------------------------------------------------
    {
        id: 'e1-2-P_1',
        source: 'P_1_1',
        target: 'P_1_2',
        animated: true,
    },
    {
        id: 'e2-3-P_1',
        source: 'P_1_2',
        target: 'P_1_3',
        animated: true,
    },
    {
        id: 'e3-4-P_1',
        source: 'P_1_3',
        target: 'P_1_6',
        animated: true,
    },
    {
        id: 'e4-5-P_1',
        source: 'P_1_6',
        target: 'P_1_5',
        animated: true,
    },
    {
        id: 'e5-6-P_1',
        source: 'P_1_5',
        target: 'P_1_4',
        animated: true,
    },
    {
        id: 'e6-1-P_1',
        source: 'P_1_4',
        target: 'P_1_1',
        animated: true,
    },
    //SEGUNDO SEMESTRE ------------------------------------------------------------------------------
    {
        id: 'e1-2-P_2',
        source: 'P_2_1',
        target: 'P_2_2',
        animated: true,
    },
    {
        id: 'e2-3-P_2',
        source: 'P_2_2',
        target: 'P_2_3',
        animated: true,
    },
    {
        id: 'e3-4-P_2',
        source: 'P_2_3',
        target: 'P_2_6',
        animated: true,
    },
    {
        id: 'e4-5-P_2',
        source: 'P_2_6',
        target: 'P_2_5',
        animated: true,
    },
    {
        id: 'e5-6-P_2',
        source: 'P_2_5',
        target: 'P_2_4',
        animated: true,
    },
    {
        id: 'e6-1-P_2',
        source: 'P_2_4',
        target: 'P_2_1',
        animated: true,
    },
    //TERCER SEMESTRE ------------------------------------------------------------------------------
    {
        id: 'e1-2-P_3',
        source: 'P_3_1',
        target: 'P_3_2',
        animated: true,
    },
    {
        id: 'e2-3-P_3',
        source: 'P_3_2',
        target: 'P_3_3',
        animated: true,
    },
    {
        id: 'e3-4-P_3',
        source: 'P_3_3',
        target: 'P_3_6',
        animated: true,
    },
    {
        id: 'e4-5-P_3',
        source: 'P_3_6',
        target: 'P_3_5',
        animated: true,
    },
    {
        id: 'e5-6-P_3',
        source: 'P_3_5',
        target: 'P_3_4',
        animated: true,
    },
    {
        id: 'e6-1-P_3',
        source: 'P_3_4',
        target: 'P_3_1',
        animated: true,
    },
    //CUARTO SEMESTRE ------------------------------------------------------------------------------
    {
        id: 'e1-2-P_4',
        source: 'P_4_1',
        target: 'P_4_2',
        animated: true,
    },
    {
        id: 'e2-3-P_4',
        source: 'P_4_2',
        target: 'P_4_3',
        animated: true,
    },
    {
        id: 'e3-4-P_4',
        source: 'P_4_3',
        target: 'P_4_6',
        animated: true,
    },
    {
        id: 'e4-5-P_4',
        source: 'P_4_6',
        target: 'P_4_5',
        animated: true,
    },
    {
        id: 'e5-6-P_4',
        source: 'P_4_5',
        target: 'P_4_4',
        animated: true,
    },
    {
        id: 'e6-1-P_4',
        source: 'P_4_4',
        target: 'P_4_1',
        animated: true,
    },
    //QUINTO SEMESTRE ------------------------------------------------------------------------------
    {
        id: 'e1-2-P_5',
        source: 'P_5_1',
        target: 'P_5_2',
        animated: true,
    },
    {
        id: 'e2-3-P_5',
        source: 'P_5_2',
        target: 'P_5_3',
        animated: true,
    },
    {
        id: 'e3-4-P_5',
        source: 'P_5_3',
        target: 'P_5_6',
        animated: true,
    },
    {
        id: 'e4-5-P_5',
        source: 'P_5_6',
        target: 'P_5_5',
        animated: true,
    },
    {
        id: 'e5-6-P_5',
        source: 'P_5_5',
        target: 'P_5_4',
        animated: true,
    },
    {
        id: 'e6-1-P_5',
        source: 'P_5_4',
        target: 'P_5_1',
        animated: true,
    },
    //SEXTO SEMESTRE ------------------------------------------------------------------------------
    {
        id: 'e1-2-P_6',
        source: 'P_6_1',
        target: 'P_6_2',
        animated: true,
    },
    {
        id: 'e2-3-P_6',
        source: 'P_6_2',
        target: 'P_6_3',
        animated: true,
    },
    {
        id: 'e3-4-P_6',
        source: 'P_6_3',
        target: 'P_6_6',
        animated: true,
    },
    {
        id: 'e4-5-P_6',
        source: 'P_6_6',
        target: 'P_6_5',
        animated: true,
    },
    {
        id: 'e5-6-P_6',
        source: 'P_6_5',
        target: 'P_6_4',
        animated: true,
    },
    {
        id: 'e6-1-P_6',
        source: 'P_6_4',
        target: 'P_6_1',
        animated: true,
    },
    //Connection of the matters ------------------------------------------------------------------------------
    {
        id: 'eP0-P1',
        source: 'P_0',
        target: 'P_1',
        animated: true,
    },
    {
        id: 'eP1-P2',
        source: 'P_1',
        target: 'P_2',
        animated: true,
    },
    {
        id: 'eP2-P3',
        source: 'P_2',
        target: 'P_3',
        animated: true,
    },
    {
        id: 'eP3-P4',
        source: 'P_3',
        target: 'P_4',
        animated: true,
    },
    {
        id: 'eP4-P5',
        source: 'P_4',
        target: 'P_5',
        animated: true,
    },
    {
        id: 'eP5-P6',
        source: 'P_5',
        target: 'P_6',
        animated: true,
    },
]